/**
 * Examfy Logo Component
 *
 * Supports multiple logo variants using SVG assets.
 */

export interface LogoProps {
  variant?: 'square' | 'rounded' | 'alter' | 'alterRounded';
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
}

export const Logo = ({
  variant = 'rounded',
  width = 32,
  height = 32,
  className,
  alt = 'Examfy',
}: LogoProps) => {
  const images = {
    square: '/images/logo.svg',
    rounded: '/images/logo.round.svg',
    alter: '/images/logo.alter.svg',
    alterRounded: '/images/logo.alter.round.svg',
  };

  return (
    <img
      src={images[variant]}
      width={width}
      height={height}
      className={className}
      alt={alt}
    />
  );
};
